/*
 * @module: 
 * @Descripttion: 
 * @Author: jinxueqiang
 * @Date: 2021-11-25 11:15:35
 * @LastEditors: wangshengjin
 * @LastEditTime: 2022-12-01 17:22:46
 */
import '@nobook/nb-log';
import { M } from '@nobook/nb-utils';

// declare var window;
// declare var NBLog;

/**
 * 阿里云日志工具
 * 产品日志地址:
 *      https://narcb9vct6.feishu.cn/wiki/wikcnG52qZwjt4U6AYYnqz6HPib#
 * 使用:
 *    const tool = new NBLogTool();
 *    // 登录成功则传递 userID(uid)
 *    tool.sendUser(userID);
 *    // 未登录或退出登录,则传递 null
 *    tool.sendUser(null);
 * 
 * 正式与测试环境(由docker环境变量配置,不配置默认正式):
 * dev: {
 *     project: 'nobook-test',
 *     logstore: 'webexam_noteach_com_cn'
 *   },
 *   prod: {
 *     project: 'nobook-prod',
 *     logstore: 'webexam_nobook_com'
 *   }
 */
export class NBLogTool {

  constructor() {
    this.initNBLog();
    // 初始化神策
    this.initSensor();
    window.nbLog = this;
  }

  initNBLog() {
    // 设备码
    // 测试环境需要将点打到 wuli-nobook-com-dev
    let { from, project, logstore } = window.__nb_alilog || {};
    // 打点组件初始化
    const aliLog = {
      from: from || 'jiashi',
      project: project || 'nobook-test',
      logstore: logstore || 'webexam_noteach_com_cn',
    };
    NBLog.config(aliLog, {
      deviceUUID: '',
      packver: '1.0.0',
      isLandscape: '',
      isMobile: '',
      subject: 'chem'
    });
  }

  /**
   * 发送用户数据统计
   * @param userID 用户id
   */
  sendUser(userID) {
    let uuid = localStorage.getItem('USER_UUID');
    if (!uuid) {
      uuid = M.getUniqueID();
      localStorage.setItem('USER_UUID', uuid);
    }
    const setParam = { uuid };
    // 有用户id就发送用户id
    if (userID) {
      setParam.userID = userID;
    }
    NBLog.send(setParam);
  }

  initSensor() {
    const sensors = window.sensorsDataAnalytic201505;
    if (!sensors) return;
    // 神策环境变量 project: 'nobook_dev' || 'nobook_prod'
    const { project, enabled, showlog } = window.__nb_sensors;
    if (!project) {
      console.log('%c~~~~~~未配置神策 project,关闭打点!!!!', 'color:red');
      return;
    }
    if (!enabled || enabled === 'false') {
      console.log(`%c~~~~~~神策打点被关闭,enabled=${enabled}`, 'color:red');
      return;
    }
    sensors.init({
      server_url: `https://et.eeo.cn/sa?project=${project}`,
      is_track_single_page: true, // 单页面配置，默认开启，若页面中有锚点设计，需要将该配置删除，否则触发锚点会多触发 $pageview 事件
      use_client_time: true,
      send_type: 'beacon',
      // heatmap_url神策分析中点击分析及触达分析功能代码，代码生成工具会自动生成。
      // 如果神策代码中 `sensorsdata.min.js` 版本是 1.9.1 及以上版本，这个参数必须配置，低于此版本不需要配置。
      heatmap_url: "https://unpkg.com/sa-sdk-javascript@1.13.11/heatmap.min.js",
      heatmap: {
        // Web 元素点击($WebClick): 是否开启点击图，default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭。
        // 默认只有点击 a input button textarea 四种元素时，才会触发 $WebClick 元素点击事件
        clickmap: 'default',
        // 视区停留事件($WebStay): 是否开启触达图，not_collect 表示关闭，不会自动采集 $WebStay 事件，可以设置 'default' 表示开启。
        scroll_notice_map: 'default',
        // 在原来的全埋点（采集 a、button、input 、textarea 标签）基础上新增对 div 标签的采集，采集规则为：
        // 1、div 为叶子结点（无子元素）时采集 div 的点击
        // 2、div 中有且只有样式标签（['mark','strong','b','em','i','u','abbr','ins','del','s','sup']）时，
        //    点击 div 或者样式标签都采集 div 的点击
        collect_tags: {
          div: true,
          li: true,
          img: true,
          svg: true,
          span: true,
          p: true,
        }
      },
      show_log: /true/.test(showlog), // 测试阶段打印log
      // 开启 cookie 加密配置，默认 false
      // encrypt_cookie: true
    });
    sensors.use('PageLoad'); // 采集页面加载时长
    sensors.use('PageLeave'); // 采集页面浏览时长,心跳记录刷新时间默认5s
    //
    window.sensors = sensors;
    window.addEventListener('beforeunload', () => {
      // dispatch({ type: 'appEnd' });
      // TODO 此函数只支持同步函数，因此临时直接发
      window.sensors.track('AppEnd', {
        duration: new Date().getTime() - NBLogTool.openTime
      });
    });
    this.startSensor(sensors);
  }

  startSensor(sensors) {
    const sessionID = M.getBase64UniqueID();
    if (!sensors) return;
    let { tenantName, pid } = window.__nb_sensors;
    if (!tenantName) tenantName = 'nobook';
    const { screen } = window;
    //
    // 注册 sensors 公共属性
    sensors.registerPage({
      // 会话ID
      sessionid() {
        return sessionID;
      },
      // 产品ID
      pid() {
        return pid;
      },
      // 产品名称
      pid_name() {
        return {
          'EXAMQGWLuC5K': '初中物理',
          'EXAMQGHXuC5K': '初中化学',
        }[pid];
      },
      // 产品版本号
      version() {
        return 'v1.3.0';
      },
      // 租户名称
      tenantname() {
        return tenantName;
      },
      // 当前页链接
      url() {
        return location.href;
      },
      // 前向页面地址
      referrer() {
        return document.referrer;
      },
      // 埋点的版本
      recordversion: () => {
        return 'v1.0.3';
      },
      // 屏幕宽度
      screen_width() {
        return screen.width;
      },
      // 屏幕高度
      screen_height() {
        return screen.height;
      },
      // 屏幕有效宽度
      screen_availwidth() {
        return screen.availWidth;
      },
      // 屏幕有效高度
      screen_availheight() {
        return screen.availHeight;
      },
      // 屏幕左偏移
      screen_availleft() {
        return screen.availLeft;
      },
      // 屏幕顶偏移
      screen_availtop() {
        return screen.availTop;
      },
      // 屏幕的旋转角度
      screen_orientationangle() {
        return screen.orientation.angle;
      },
      // 屏幕颜色深度
      screen_colordepth() {
        return screen.colorDepth;
      },
      // 屏幕像素深度
      screen_pixeldepth() {
        return screen.pixelDepth;
      },
      // 是否为扩展屏
      screen_isextended() {
        return !!screen.isExtended;
      },
      // 屏幕最多支持多少个点
      screen_maxtouchpoints() {
        return navigator.maxTouchPoints;
      },
      // 平台类型
      platform_type: 'web',
    });
    // 是否第一次启动
    this.sendAppStart();
    sensors.quick('autoTrack'); // 用于采集 $pageview 事件
  }

  /**
  * 是否第一次启动
  */
  sendAppStart() {
    let isfirststart = 0;
    const TJ_APPSTART_ISFIRSTSTART = 'tj_appStart_isFirstStart';
    const str = localStorage.getItem(TJ_APPSTART_ISFIRSTSTART);
    if (str === null) {
      isfirststart = 1;
      localStorage.setItem(TJ_APPSTART_ISFIRSTSTART, '1');
    }
    this.track({
      AppStart: {
        isfirststart,
      }
    });
  }

  track(param) {
    const { sensors } = window;
    if (!sensors) return;
    Object.keys(param).map(key => {
      sensors.track(key, param[key]);
    });
  }
}



// WEBPACK FOOTER //
// ./src/NBLogTool.js